import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { reactive, ref, toRefs } from "vue";
import apis from "@/api";
export default {
  components: {},
  setup(props, ctx) {
    const treeRef = ref({});
    const defaultProps = {
      label: "nodeName",
      children: "children"
    };
    const data = reactive({
      dialogVisible: false,
      defaultExpandedeys: ["001"],
      onlineLoading: true,
      offlineLoading: true
    });
    const loadNode = (node, resolve) => {
      if (node.level === 0) {
        return resolve([{
          nodeName: '互联网渠道物料',
          id: '001',
          leaf: 0
        }, {
          nodeName: '宣传设计制作物料',
          id: '002',
          leaf: 0
        }, {
          nodeName: '短信',
          id: '003',
          leaf: 0
        }]);
      }
      if (node.level > 0) {
        getChild(node.data.id, resolve);
      }
    };
    const getChild = (pId, resolve) => {
      apis.queryPositionChild(pId).then(res => {
        if (res.success) {
          if (res.data.length > 0) {
            res.data.forEach(val => {
              val.isLeaf = val.positionType == 2 ? 1 : 0;
            });
          }
          resolve(res.data);
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const close = () => {
      data.dialogVisible = false;
    };
    const confirmHandler = () => {
      let position = treeRef.value.getCurrentNode();
      if (position.positionType !== 2) {
        ElMessage.warning("请选择运营位节点");
        return;
      }
      ctx.emit("ok", position);
      close();
    };
    const visible = () => {
      data.dialogVisible = true;
    };
    return {
      ...toRefs(data),
      defaultProps,
      loadNode,
      getChild,
      close,
      visible,
      confirmHandler,
      treeRef
    };
  }
};